<template>
  <div id="pages-medias">
  <div id="active-page" :class="{'page-fade': !mountedPage}"></div>
    <itt-lightbox @closed="infoShowReport = null" :show-report="infoShowReport"></itt-lightbox>
    <modal-del-report :reports="selectedReports"></modal-del-report>
    <itt-download-reports :reports="selectedReports"></itt-download-reports>
    <v-container fluid grid-list-xl>
      <v-breadcrumbs :items="breadcrumbs" divider="►" dark id="breadcrumbs">
        <v-breadcrumbs-item
          @click="emptySelectImg"
          slot="item"
          slot-scope="{ item }"
          exact
          :to="item.to">
          {{ item.text }}
        </v-breadcrumbs-item>
      </v-breadcrumbs>
      <div v-if="loader" class="loader-page-medias">
        <v-icon>mdi-loading mdi-spin</v-icon>
      </div>
      <div v-else-if="allElements.length === 0" class="loader-page-medias">
        <p>{{$t('texts.noImgYet')}}</p>
      </div>
      <v-layout row wrap :class="`mini-p-${grid}`">
        <img-and-select
          v-for="element in allElements"
          :key="element.uuid"
          :class="`xs${grid}`"
          :element="element"
          @update-select="updateSelect"
          :selectionable="true"
          :clickable="true"
          @show-img="showReport" 
        />
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import ittImgDetailProject from "@/components/img-detail-project"
import ittImgMiniature from "@/components/img-miniature"
import imgAndSelect from "@/components/img-and-select"
import modalDelReport from "@/components/modals-form/modal-del-report";
import ittLightbox from "@/components/lightbox";
import ittDownloadReports from "@/components/itt-download-reports";
export default {
  components: {
    ittImgMiniature,
    ittImgDetailProject,
    imgAndSelect,
    modalDelReport,
    ittLightbox,
    ittDownloadReports
  },
  watch: {
    filter(filter) {
      this.applyFilter(filter);
    },    
    $route(to, from) {
      this.getBreadcrumbs();
      this.selectedReports = {}
      this.infoShowReport = null;
    },
  },
  beforeCreate() {
    this.$store.dispatch("image/getImages");
  },
  beforeMount() {
    this.getBreadcrumbs();
    (async () => await this.$store.dispatch("project/getProjects").then(() => {
    if (this.breadcrumbs.length === 0)
      this.getBreadcrumbs();
    }))();
  },
  data() {
    return {
      srcToLightbox: '',
      imgProject: null,
      oldElement: null,
      loader: true,
      allElements: null,
      selectedReports: {},
      infoShowReport: null,
      breadcrumbs: [],
      mountedPage: false
    };
  },
  asyncComputed: {
    async getElements() {
      let elements = await this.$store.getters[
        "image/getImgProject"
      ](this.$route.params.uuid);
      if (elements === null) return;
      this.loader = false;
      this.allElements =  elements;
      this.applyFilter(this.filter);
    },
    async grid() {
      return this.$store.getters["image/getFilterResponsivity"];
    },
  },
  computed: {
    filter() {
      let filter = this.$store.getters["image/getFilter"];
      return filter;
    },
  },
  methods: {
    async emptySelectImg() {
      this.$store.commit('image/emptyMultiSelectImg')
      let projUuid = this.$router.currentRoute.fullPath.slice(10);
      if (projUuid === '') return;
      let proj = await this.$store.dispatch("project/getProject", projUuid);
      this.$store.commit("project/setLatestProj", proj);

    },
    applyFilter(filter) {
      if (filter === 'a-z')
        this.allElements.sort((a, b) => a.name < b.name ? -1 : 1);
      else if (filter === 'date')
        this.allElements.sort((a, b) => a.created < b.created ? 1 : -1);
    },
    updateSelect(infoReport) {
      let uuid = Object.keys(infoReport)[0];
      this.$set(this.selectedReports, uuid, infoReport[uuid]);
    },
    showReport(infoShowReport) {
      this.infoShowReport = infoShowReport
    },
    getBreadcrumbs() {
      let uuidProj = this.$route.params.uuid;
      let projects = this.$store.getters["project/getProjects"];
      if (projects === 'null') return;
      let currentProj = projects.find((proj) => proj.uuid === uuidProj);
      if (currentProj === undefined) return;
      this.breadcrumbs = [{
          text: this.$t('titles.allProjects'),
          disabled: false,
          to: '/projects/'
        }, {
          text: currentProj.name,
          disabled: true,
          to: '/projects/' + currentProj.uuid
        }];
      if (currentProj.parent !== null) {
        this.breadcrumbs[1].disabled = false;
        uuidProj = currentProj.parent;
        let parentProj = projects.find((proj) => proj.uuid === uuidProj);
        this.breadcrumbs.splice(1, 0, {
          text: parentProj.name,
          disabled: true,
          to: '/projects/' + parentProj.uuid
        })
      }
    }
  },
  mounted() {
    setTimeout(() => this.mountedPage = true, 100);
  }
};
</script>
<style lang="sass">

$active: #f1e341
#pages-medias
  .mini-p-1
    padding-left: 1rem
    padding-right: 1rem
.contain-text 
  word-break: break-all
  padding: 0 10px
  text-align: center
  display: block

.loader-page-medias 
  position: absolute
  // z-index: 20px
  top: 60%
  left: 50%
  transform: translate(-50%, -50%)
  text-align: center

.loader-page-medias i 
  font-size: 4rem

// BREADCUMBS

#breadcrumbs
  padding-top: 0
  padding-bottom: 0
  .v-breadcrumbs__item
    color: white !important
    font-size: 1.5rem
    font-weight: normal !important
  .v-breadcrumbs__item--disabled
    color: $active !important
  .v-breadcrumbs__divider
    color: white !important

</style>
